import { TrendingUp, LucideIcon } from 'lucide-react';

export type Product = {
  slug: string;
  title: string;
  description: string;
  icon: LucideIcon;
  href: string;
};

export const products: Product[] = [
  {
    slug: 'debtcast',
    icon: TrendingUp,
    title: "DebtCast",
    description: "Your trusted digital repository to curate, discover, and share knowledge from your data and documents, enhanced with AI.",
    href: "/products/debtcast"
  }
];
